import React from 'react';
import { Type } from '../../../../../general/modules/filter/dataModel';

import { FileManagerRow, FMColumn } from '../../model';

import './styles.scss';

export const GenreCellInner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<Type.ID>;
}> = ({ rowData }) => {
  const genres = rowData.creative?.genres ?? [];
  // fallback на старое single-поле для креативов, где бэк не отдал `genres`
  const fallback = rowData.creative?.genre;

  const names = genres.length > 0 ? genres.map((g) => g.name) : fallback ? [fallback.name] : [];

  if (names.length === 0) {
    return <span></span>;
  }

  const joined = names.join(', ');
  return <span title={joined}>{joined}</span>;
};
